import { render } from "./UnitDetail.vue?vue&type=template&id=326bf334"
import script from "./UnitDetail.vue?vue&type=script&lang=js"
export * from "./UnitDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__